import { ListItemIcon, MenuItem } from "@mui/material";

type TableRowActionProps = {
  disabled?: boolean;
  icon: React.ReactNode;
  text?: string;
  onClick: () => void;
};

const TableRowAction: React.FC<TableRowActionProps> = (props) => {
  const { onClick, icon, text, disabled } = props;

  if (disabled) return null;

  return (
    <MenuItem onClick={onClick} disabled={disabled}>
      <ListItemIcon>{icon}</ListItemIcon>
      {text}
    </MenuItem>
  );
};

export default TableRowAction;
